module.exports = __webpack_public_path__ + "img/kumo_2.dc300b5f.svg";